import i18n from 'i18next';
import TimeAgo from 'javascript-time-ago';
import timeAgoEn from 'javascript-time-ago/locale/en';
import timeAgoKo from 'javascript-time-ago/locale/ko';
import Cookies from 'js-cookie';
import { initReactI18next, useTranslation } from 'react-i18next';

import en from './en';
import ko from './ko';

export type Lang = 'ko' | 'en';

const toLang = (value: string | undefined): Lang => (value === 'en' ? 'en' : 'ko');

TimeAgo.addLocale(timeAgoEn);
TimeAgo.addLocale(timeAgoKo);

const timeAgos: Record<Lang, TimeAgo> = { ko: new TimeAgo('ko'), en: new TimeAgo('en') };

i18n.use(initReactI18next).init({
  resources: { en, ko },
  lng: toLang(Cookies.get('HYUNSUB_LANG')),
  fallbackLng: 'ko',
  interpolation: {
    escapeValue: false,
  },
});

/**
 * 지금 언어. 언어는 계정 메뉴에서 새로고침 없이 바뀌므로 상수로 들고 있지 말고 쓸 때마다 읽는다.
 * 컴포넌트 렌더 안에서는 언어가 바뀔 때 다시 그려지도록 `useLang()`을 쓴다.
 */
export const getLang = (): Lang => toLang(i18n.language);

export const getTimeAgo = (): TimeAgo => timeAgos[getLang()];

/** 지금 언어를 구독한다. 언어가 바뀌면 이 훅을 쓴 컴포넌트가 다시 그려진다. */
export function useLang(): Lang {
  const { i18n: instance } = useTranslation();
  return toLang(instance.language);
}

/** `getTimeAgo()`의 컴포넌트용. 언어가 바뀌면 다시 그려진다. */
export const useTimeAgo = (): TimeAgo => timeAgos[useLang()];

/** 문구·날짜 언어를 바로 바꾼다(저장은 auth API가 따로 한다). */
export async function changeLang(lang: Lang) {
  TimeAgo.setDefaultLocale(lang);
  document.documentElement.lang = lang;
  await i18n.changeLanguage(lang);
}

TimeAgo.setDefaultLocale(getLang());
document.documentElement.lang = getLang();
